export const YEAR_MONTH_DAY = "YYYY-MM-DD";
export const DAY_MONTH_YEAR = "DD-MM-YYY";
export const MONTH_YEAR = "MMM YYYY";
export const DAY_MONTH = "DD MMM";
export const DAY_MONTH_YEAR_SLASH = "DD/MM/YYYY";

export const HOUR_MIN = "HH:mm";
